import React, { useEffect, useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import cls from "../styles/SolutionsMobileMenu.module.scss";
import { HiOutlineChevronDown, HiOutlineViewList } from "react-icons/hi";
import { landingPageTypes } from "@/constant";
export const SolutionsMobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={cls.mobile_menu__container} data-sentry-component="SolutionsMobileMenu" data-sentry-source-file="SolutionsMobileMenu.tsx">
      <div className={cls.mobile_menu} onClick={() => setIsOpen(!isOpen)}>
        <div>
          <HiOutlineViewList size={24} color="#3C3C3C" data-sentry-element="HiOutlineViewList" data-sentry-source-file="SolutionsMobileMenu.tsx" />
          <p className={cls.mobile_menu__title}>NAVIGATE TO</p>
          <motion.div animate={{
          rotate: !isOpen ? 0 : 180
        }} data-sentry-element="unknown" data-sentry-source-file="SolutionsMobileMenu.tsx">
            <HiOutlineChevronDown size={24} color="#3C3C3C" data-sentry-element="HiOutlineChevronDown" data-sentry-source-file="SolutionsMobileMenu.tsx" />
          </motion.div>
        </div>
        {isOpen && <hr />}
        <motion.ul animate={{
        display: isOpen ? "block" : "none"
      }} data-sentry-element="unknown" data-sentry-source-file="SolutionsMobileMenu.tsx">
          {landingPageTypes?.map(item => <li key={item.type}>
              <Link href={`#${item.type}`}>{item.dashboardTypeTitle}</Link>
            </li>)}
        </motion.ul>
      </div>
    </div>;
};